<label
  class="commodity-search"
  [attr.for]="undefined"
  [class.viewonly]="viewOnly"
  [class.invalid]="showError"
  [class.focused]="isFocused"
  caiTooltip
  [tooltip]="input.value"
  [detectOverflow]="true"
  [target]="input"
>
  <input
    #input
    [placeholder]="label"
    [(ngModel)]="display"
    (ngModelChange)="changeQuery($event)"
    (keyup)="keyup($event)"
    (blur)="blur()"
    (focus)="enableSuggestions()"
    [disabled]="viewOnly ? true : null"
  />
  <span class="label">{{ label }}</span>

  <ng-template #dropdown>
    <div class="dropdown">
      @if (!showSuggestions) {
        <div class="dropdown-total">
          <span>TOTAL RESULTS ({{ options?.length }})</span>
        </div>
      }
      <div class="dropdown-inner">
        @if (!showSuggestions && !showNoResults) {
          @for (option of options; track option) {
            <div class="option" (mousedown)="select(option)">
              <div class="header">
                @if (option.type === commoditySearchTypes.COMMODITY) {
                  @if (getSHCs(option.object); as shcList) {
                    @for (shc of shcList; track shc) {
                      <div class="title commodity-title">
                        <span>SHC</span>
                        <span [innerHtml]="getHighlightedText(shc)"></span>
                      </div>
                    }
                  }
                  @if (getSCRs(option.object); as scrList) {
                    @for (scr of scrList; track scr) {
                      <div class="title commodity-title">
                        <span>SCR</span>
                        <span [innerHtml]="getHighlightedText(scr)"></span>
                      </div>
                    }
                  }
                  @if (getHS(option.object); as hs) {
                    <div class="title commodity-title">
                      <span>HS</span>
                      <span [innerHtml]="getHighlightedText(hs)"></span>
                    </div>
                  }
                }
                @if (option.type === commoditySearchTypes.DANGEROUS_GOOD) {
                  <div class="title">
                    <span>UN</span>
                    <span
                      [innerHtml]="getHighlightedText(option.object.id)"
                    ></span>
                  </div>
                }
              </div>
              <div class="body">
                @if (option.type === commoditySearchTypes.COMMODITY) {
                  @if (option.object.name && option.object.level <= 2) {
                    <div class="commodity-name">
                      <span
                        [innerHtml]="getHighlightedText(option.object.name)"
                      >
                      </span>
                    </div>
                  }
                  @if (option.object.name && option.object.level > 2) {
                    <div class="commodity-items">
                      <span>
                        <svg
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4.64342 1.01073C4.31115 0.942388 3.96844 0.942388 3.63616 1.01073C3.25948 1.0882 2.91221 1.2813 2.4099 1.5606L2.34291 1.59784L1.90316 1.84215L1.83214 1.88158L1.83214 1.88158C1.30173 2.17598 0.935174 2.37943 0.661624 2.67627C0.573232 2.77219 0.492718 2.87462 0.420685 2.98254C0.355471 3.02689 0.299824 3.08735 0.260356 3.1619C0.22253 3.23335 0.203758 3.30982 0.202249 3.38548C0.174108 3.45113 0.148743 3.51807 0.126254 3.58614C-0.000384114 3.96943 -0.00021877 4.38867 2.03634e-05 4.9953L4.15827e-05 5.07653V5.35492L2.03634e-05 5.43615C-0.00021877 6.04278 -0.000384114 6.46202 0.126254 6.8453C0.23791 7.18324 0.420436 7.49345 0.661624 7.75517C0.935175 8.05201 1.30174 8.25547 1.83214 8.54987L1.90316 8.5893L2.34291 8.8336L2.4099 8.87084C2.91221 9.15015 3.25948 9.34325 3.63616 9.42072C3.7017 9.4342 3.76765 9.44502 3.83384 9.45318C3.91841 9.51869 4.02455 9.55768 4.13979 9.55768C4.25504 9.55768 4.36118 9.51869 4.44574 9.45318C4.51193 9.44502 4.57788 9.4342 4.64342 9.42072C5.0201 9.34325 5.36736 9.15015 5.86966 8.87085L5.86967 8.87085L5.93667 8.8336L6.37642 8.5893L6.44744 8.54987C6.97785 8.25547 7.34441 8.05201 7.61796 7.75517C7.85915 7.49345 8.04167 7.18324 8.15333 6.8453C8.27997 6.46202 8.2798 6.04278 8.27956 5.43615L8.27954 5.35492V5.07653L8.27956 4.99529C8.2798 4.38866 8.27997 3.96943 8.15333 3.58614C8.13084 3.51807 8.10548 3.45113 8.07734 3.38548C8.07583 3.30982 8.05705 3.23335 8.01923 3.1619C7.97976 3.08735 7.92411 3.02689 7.8589 2.98254C7.78687 2.87462 7.70635 2.77219 7.61796 2.67627C7.34441 2.37943 6.97785 2.17598 6.44744 1.88158L6.37642 1.84215L5.93667 1.59784L5.86968 1.5606C5.36737 1.2813 5.0201 1.0882 4.64342 1.01073ZM6.77667 3.25398C6.62492 3.12845 6.38821 2.99266 5.89078 2.71631L5.45103 2.472C4.85551 2.14116 4.64945 2.0329 4.44197 1.99022C4.2426 1.94922 4.03698 1.94922 3.83762 1.99022C3.63013 2.0329 3.42407 2.14116 2.82856 2.472L2.38881 2.7163C1.89137 2.99266 1.65467 3.12845 1.50292 3.25398L4.13979 4.64998L6.77667 3.25398ZM1.02585 4.13291C1.00276 4.32191 1.00004 4.59173 1.00004 5.07653V5.35492C1.00004 6.07461 1.00604 6.32055 1.07577 6.53158C1.14276 6.73435 1.25228 6.92047 1.39699 7.0775C1.54761 7.24094 1.75968 7.36562 2.3888 7.71514L2.82856 7.95945C3.24466 8.19062 3.47063 8.31312 3.63979 8.3805V5.51676L1.02585 4.13291ZM4.63979 8.3805C4.80896 8.31312 5.03492 8.19062 5.45103 7.95945L5.89078 7.71514C6.51991 7.36562 6.73198 7.24094 6.88259 7.0775C7.02731 6.92047 7.13682 6.73435 7.20382 6.53158C7.27354 6.32055 7.27954 6.07461 7.27954 5.35492V5.07653C7.27954 4.59173 7.27682 4.32191 7.25373 4.13291L4.63979 5.51676V8.3805Z"
                            fill="#B6B6B6"
                          />
                        </svg>
                      </span>
                      <span
                        [innerHtml]="getHighlightedText(option.object.name)"
                      ></span>
                    </div>
                  }
                }
                @if (option.type === commoditySearchTypes.DANGEROUS_GOOD) {
                  @if (option.object.groupName) {
                    <div class="group-name">
                      <span
                        [innerHtml]="
                          getHighlightedText(option.object.groupName)
                        "
                      >
                      </span>
                    </div>
                  }
                  @if (option.object.description) {
                    <div class="description">
                      <span
                        [innerHtml]="
                          getHighlightedText(option.object.description)
                        "
                      >
                      </span>
                    </div>
                  }
                  @if (getGroupItems(option.object.groupItems); as groupItems) {
                    <div class="group-items">
                      @for (item of groupItems; track item) {
                        <span>
                          <svg
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M4.64342 1.01073C4.31115 0.942388 3.96844 0.942388 3.63616 1.01073C3.25948 1.0882 2.91221 1.2813 2.4099 1.5606L2.34291 1.59784L1.90316 1.84215L1.83214 1.88158L1.83214 1.88158C1.30173 2.17598 0.935174 2.37943 0.661624 2.67627C0.573232 2.77219 0.492718 2.87462 0.420685 2.98254C0.355471 3.02689 0.299824 3.08735 0.260356 3.1619C0.22253 3.23335 0.203758 3.30982 0.202249 3.38548C0.174108 3.45113 0.148743 3.51807 0.126254 3.58614C-0.000384114 3.96943 -0.00021877 4.38867 2.03634e-05 4.9953L4.15827e-05 5.07653V5.35492L2.03634e-05 5.43615C-0.00021877 6.04278 -0.000384114 6.46202 0.126254 6.8453C0.23791 7.18324 0.420436 7.49345 0.661624 7.75517C0.935175 8.05201 1.30174 8.25547 1.83214 8.54987L1.90316 8.5893L2.34291 8.8336L2.4099 8.87084C2.91221 9.15015 3.25948 9.34325 3.63616 9.42072C3.7017 9.4342 3.76765 9.44502 3.83384 9.45318C3.91841 9.51869 4.02455 9.55768 4.13979 9.55768C4.25504 9.55768 4.36118 9.51869 4.44574 9.45318C4.51193 9.44502 4.57788 9.4342 4.64342 9.42072C5.0201 9.34325 5.36736 9.15015 5.86966 8.87085L5.86967 8.87085L5.93667 8.8336L6.37642 8.5893L6.44744 8.54987C6.97785 8.25547 7.34441 8.05201 7.61796 7.75517C7.85915 7.49345 8.04167 7.18324 8.15333 6.8453C8.27997 6.46202 8.2798 6.04278 8.27956 5.43615L8.27954 5.35492V5.07653L8.27956 4.99529C8.2798 4.38866 8.27997 3.96943 8.15333 3.58614C8.13084 3.51807 8.10548 3.45113 8.07734 3.38548C8.07583 3.30982 8.05705 3.23335 8.01923 3.1619C7.97976 3.08735 7.92411 3.02689 7.8589 2.98254C7.78687 2.87462 7.70635 2.77219 7.61796 2.67627C7.34441 2.37943 6.97785 2.17598 6.44744 1.88158L6.37642 1.84215L5.93667 1.59784L5.86968 1.5606C5.36737 1.2813 5.0201 1.0882 4.64342 1.01073ZM6.77667 3.25398C6.62492 3.12845 6.38821 2.99266 5.89078 2.71631L5.45103 2.472C4.85551 2.14116 4.64945 2.0329 4.44197 1.99022C4.2426 1.94922 4.03698 1.94922 3.83762 1.99022C3.63013 2.0329 3.42407 2.14116 2.82856 2.472L2.38881 2.7163C1.89137 2.99266 1.65467 3.12845 1.50292 3.25398L4.13979 4.64998L6.77667 3.25398ZM1.02585 4.13291C1.00276 4.32191 1.00004 4.59173 1.00004 5.07653V5.35492C1.00004 6.07461 1.00604 6.32055 1.07577 6.53158C1.14276 6.73435 1.25228 6.92047 1.39699 7.0775C1.54761 7.24094 1.75968 7.36562 2.3888 7.71514L2.82856 7.95945C3.24466 8.19062 3.47063 8.31312 3.63979 8.3805V5.51676L1.02585 4.13291ZM4.63979 8.3805C4.80896 8.31312 5.03492 8.19062 5.45103 7.95945L5.89078 7.71514C6.51991 7.36562 6.73198 7.24094 6.88259 7.0775C7.02731 6.92047 7.13682 6.73435 7.20382 6.53158C7.27354 6.32055 7.27954 6.07461 7.27954 5.35492V5.07653C7.27954 4.59173 7.27682 4.32191 7.25373 4.13291L4.63979 5.51676V8.3805Z"
                              fill="#B6B6B6"
                            />
                          </svg>
                          <span
                            class="ps-1"
                            [innerHtml]="getHighlightedText(item)"
                          >
                          </span>
                        </span>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        @if (showNoResults) {
          <div class="no-results">
            <div i18n="@@global.no-results-found">NO RESULTS FOUND</div>
            @if (noResultsText) {
              <div>{{ noResultsText }}</div>
            }
          </div>
        }
        @if (showSuggestions) {
          <div class="suggestions">
            <div class="suggestions-title">
              <span>Search for commodity on any level of details:</span>
            </div>
            <ul>
              @for (suggestion of commoditySuggestions; track suggestion) {
                <li>
                  <span>{{ suggestion.label }}</span>
                  <span></span>
                  <span>{{ suggestion.description }}</span>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </ng-template></label
>
